export function setTimezoneHeader(config) {
  if (!config.headers) {
    config.headers = {}
  }
  config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone

  return config
}
